export default __webpack_public_path__ + "static/media/pictogramBeaconUpload128.3a9a4838.svg";